import { Flex, List, Typography } from 'antd';
import cn from 'classnames';

import VideoPlatformLink from '@/components/common/VideoPlatformLink';
import VideoPlayer from '@/components/common/VideoPlayer';
import { CDN_URL } from '@/const';
import useTabVideoPlayer from '@/hooks/useTabVideoPlayer';
import placeholderImg from '@/lib/assets/placeholder.jpg';
import prepareCdnVideoUrl from '@/lib/helpers/prepareCdnVideoUrl';
import prepareImageSrc from '@/lib/helpers/prepareImageSrc';

import styles from '../../styles.module.css';

import { TActiveMenuTab } from '../..';

// import { TTitle, titles } from '../data.tsx';

type TProps = {
	item: any;
	activeTab: TActiveMenuTab;
};

export default function PromptsEvaluation({ activeTab, item }: TProps) {
	const { wrapperRef, playerRef } = useTabVideoPlayer(
		activeTab,
		'prompts-evaluation',
	);

	const videoCdnUrl = item?.content?.metaData?.cdnPath;

	if (activeTab !== 'prompts-evaluation') {
		return null;
	}

	const prompts = item?.ml_api_data?.prompts;

	return (
		<Flex gap={16} align="flex-start" className={styles.flexWrapper} vertical>
			<Flex
				vertical
				align="center"
				className={styles.videoWrapper}
				gap={16}
				style={{ width: '100%' }}
			>
				<div className={styles.imageWrapper} ref={wrapperRef}>
					{videoCdnUrl && (
						<VideoPlayer
							playerRef={playerRef}
							preview={
								!item?.content?.metaData?.thumbnail.includes('.cdninstagram.')
									? item?.content?.metaData?.thumbnail
									: placeholderImg
							}
							url={prepareCdnVideoUrl(videoCdnUrl)}
							// isInstagramCdn={item?.metaData?.thumbnail.includes(
							//   ".cdninstagram."
							// )}
							// hasImg={!item?.metaData?.thumbnail}
						/>
					)}
					{!videoCdnUrl && (
						<>
							{item?.content?.metaData?.thumbnail &&
							!item?.content?.metaData?.thumbnail.includes('.cdninstagram.') ? (
								<img
									src={
										item?.content?.metaData?.thumbnail?.startsWith('http')
											? item?.content?.metaData?.thumbnail
											: CDN_URL +
											  prepareImageSrc(item?.content?.metaData?.thumbnail)
									}
									alt=""
								/>
							) : (
								<img
									src={placeholderImg}
									width={130}
									height={124}
									alt="'Image not found' placeholder"
								/>
							)}
						</>
					)}
				</div>
				<VideoPlatformLink item={item} />
			</Flex>
			<Flex
				vertical
				align="flex-start"
				gap={8}
				className={styles.metaContentWrapper}
			>
				{/* <Typography.Title level={4} className={cn(styles.tabTitle, styles.mb0)}>
					<span className={styles.underline}>Prompts Evaluation</span>
				</Typography.Title> */}
				<Flex vertical gap={4} align="flex-start" style={{ width: '100%' }}>
					<Flex
						vertical
						key={'entity-items'}
						style={{
							width: '100%',
							textAlign: 'left',
						}}
					>
						{prompts?.length > 0 ? (
							<List
								itemLayout="horizontal"
								className={styles.keyInsights}
								dataSource={prompts ?? []}
								renderItem={(item: any, index) => (
									<List.Item
										key={index}
										// style={{ paddingLeft: "8px" }}
									>
										<Flex vertical gap={8} key={index}>
											<Typography.Title
												level={5}
												style={{ marginTop: 0, marginBottom: 0 }}
											>
												Title:{' '}
												<span style={{ fontWeight: 400 }}>{item?.title}</span>
											</Typography.Title>

											<Typography.Text>
												<span style={{ fontWeight: 'bold' }}>Prompt:</span>{' '}
												<span style={{ fontStyle: 'italic' }}>
													{item?.prompt}
												</span>
											</Typography.Text>

											<Typography.Text>
												<span style={{ fontWeight: 'bold' }}>Trigger:</span>{' '}
												<span>{item?.trigger?.join(', ')}</span>
											</Typography.Text>

											<Typography.Text>
												<span style={{ fontWeight: 'bold' }}>Evaluation:</span>{' '}
												{item?.evaluation}
											</Typography.Text>
										</Flex>
									</List.Item>
								)}
							/>
						) : (
							<span style={{ color: 'gray' }}>n/a</span>
						)}
					</Flex>
				</Flex>
			</Flex>
		</Flex>
	);
}
